import PropTypes from "prop-types";

export const MapContactModel = {
    id: PropTypes.number,
    isSelected: PropTypes.bool,
    contactType: PropTypes.number,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    locationId: PropTypes.number,
    displayName: PropTypes.string,
    addressInfo: PropTypes.string,
    marker: PropTypes.object
};

export const ListContactModel = {
    id: PropTypes.number,
    displayName: PropTypes.string,
    location: PropTypes.string,
    type: PropTypes.string
};

export const FunctionContactModel = {
    id: PropTypes.string, // function_[id] or plan_[id]
    name: PropTypes.string,
    callTrees: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        contacts: PropTypes.arrayOf(PropTypes.shape(ListContactModel))
    })),
    teams: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        contacts: PropTypes.arrayOf(PropTypes.shape(ListContactModel))
    }))
};

export const ContactsByGroupModel = {
    events: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        description: PropTypes.string,
        type: PropTypes.string,
        functions: PropTypes.arrayOf(PropTypes.shape(FunctionContactModel))
    })),
    eventlessFunctions: PropTypes.arrayOf(PropTypes.shape(FunctionContactModel))
};
